import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
interface IV12RetailFinanceInfoContentBlock {
    text?: string;
}
interface IV12RetailFinanceInfoContentBlockData extends Catalog.IBlockData<IV12RetailFinanceInfoContentBlock> {
}
@Component({
    selector: 'v12-retail-finance-info',
    templateUrl: 'v12-retail-finance-info.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, ICmsClientModule]
})
@ICmsComponent<V12RetailFinanceInfoComponent>({
    id: 'v12-retail-finance-info',
    name: 'V12 Retail Finance Info',
    description: 'Content block used to display v12 retail finance payment text',
    fields: [
        <NICmsContentField.IField>{
            key: 'text',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Text',
            required: true
        }
    ]
})
export class V12RetailFinanceInfoComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    content?: IV12RetailFinanceInfoContentBlockData;
}
